import React, { useState, useRef } from 'react';
import Footer from '../components/footer';
import Slider from "react-slick";
import { Button } from 'reactstrap';

const tutorials = [
  {
    id: 0,
    image: '/images/tutorial-1.svg',
    title: 'Play',
    description: 'in presentations witch include quizzes'
  },
  {
    id: 1,
    image: '/images/tutorial-2.svg',
    title: 'Participate',
    description: 'in presentations witch include forums'
  },
  {
    id: 2,
    image: '/images/tutorial-3.svg',
    title: 'Organize',
    description: 'your own schedule with selected presentations and appointment'
  }
]

const Tutorial:React.FC<{locale:string; setLocale:any;}> = ({locale, setLocale}) => {
  const [updateCount, setUpdateCount] = useState(0);
  const sliderRef = useRef() as React.MutableRefObject<Slider>;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    // afterChange: (index:number) => setSlideIndex(index + 1),
    beforeChange: (current:any, next:any) => setUpdateCount(next + 1),
  };
  return (
    <div className="tutorial-landing">
      <div className="tutorial-container">
        <div className="tutorial">
          <div className="close-tutorial">
          skip features <Button onClick={() => alert('Navigate to page')} color="link"><img src="/icons/close.svg" alt="close" /></Button>
          </div>
          <Slider ref={sliderRef} className="tutorial-slider" {...settings}>
            {
              tutorials.map(tutorial => (
                <div key={tutorial.id} className="tutorial-item">
                  <img src={tutorial.image} alt={tutorial.title} />
                  <h4>{tutorial.title}</h4>
                  <p>{tutorial.description}</p>
                </div>
              ))
            }
          </Slider>
          {
            updateCount === tutorials.length ? <Button onClick={() => alert('Navigate to page')} color="primary">Close</Button> :
            <Button onClick={() => sliderRef.current.slickNext()} color="primary">Next</Button>
          }
        </div>
      </div>
      <Footer />
    </div>
  )
}
export default Tutorial;